import React from 'react';
import { ArrowUp } from 'lucide-react';

interface ScrollToTopProps {
  isVisible: boolean;
}

const ScrollToTop: React.FC<ScrollToTopProps> = ({ isVisible }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      className={`fixed bottom-6 right-6 p-3 bg-secondary-600 text-white rounded-full shadow-lg transition-all duration-300 focus:outline-none hover:bg-secondary-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <ArrowUp size={20} />
    </button>
  );
};

export default ScrollToTop;